import { useEffect, useRef, type FC } from 'react'

type UseReportUnsavedChangesArgs = {
  formikDirty: boolean
  companyBusinessId?: string
  initialBusinessId?: string
  imageIds: string[]
  documentIds: string[]
  attachmentsReady: boolean
  isUploadingFiles: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

const attachmentKey = (imageIds: string[], documentIds: string[]) =>
  [...imageIds, ...documentIds].sort().join('|')

export const useReportUnsavedChanges = ({
  formikDirty,
  companyBusinessId,
  initialBusinessId,
  imageIds,
  documentIds,
  attachmentsReady,
  isUploadingFiles,
  onDirtyChange
}: UseReportUnsavedChangesArgs) => {
  const initialAttachmentKey = useRef<string | null>(null)
  const currentAttachmentKey = attachmentKey(imageIds, documentIds)

  if (attachmentsReady && initialAttachmentKey.current === null) {
    initialAttachmentKey.current = currentAttachmentKey
  }

  const attachmentsChanged =
    initialAttachmentKey.current !== null && currentAttachmentKey !== initialAttachmentKey.current

  const isDirty =
    formikDirty || companyBusinessId !== initialBusinessId || attachmentsChanged || isUploadingFiles

  useEffect(() => {
    onDirtyChange?.(isDirty)
  }, [isDirty, onDirtyChange])
}

export const UnsavedChangesReporter: FC<UseReportUnsavedChangesArgs> = (props) => {
  useReportUnsavedChanges(props)
  return null
}
